import { Space } from 'antd';
import React from 'react';

export default function SummaryDivider({ title, icon }) {
  return (
    <Space
      className={'bg-light-grey-3 w-full br5 pd-8 mg-bottom-20 mg-top-10'}
      direction={'horizontal'}
      align={'center'}
      style={{ justifyContent: 'center' }}
    >
      <span className={'brFull bg-white sb-black-blue pd-6 center fs-12'}>
        {icon}
      </span>
      <h3 className={'gSemiBold fs-18 mg-bottom-0 '} style={{ lineHeight: 1 }}>
        {title}
      </h3>
    </Space>
  );
}